<template>
  <v-layout>
    <v-flex xs12>
      <p v-if="loading">Loading</p>
      <v-list :key="item.id" v-for="item in items" v-else>
        <router-link :to="{name: 'business-trip-imposition-detail', params: {id: item.id}}">
          <v-card>
              <v-card-title>{{item.impositionName}} | {{item.organization.name}}</v-card-title>
              <v-card-text>{{item.remark}}</v-card-text>
          </v-card>
        </router-link>
      </v-list>
    </v-flex>
  </v-layout>
</template>

<script>
import InputForm from '@/components/InputForm'
import ActionBase from '@/components/ActionBase'

export default {
  name: 'business-trip-imposition',
  extends: ActionBase,
  components: {
    InputForm
  },
  data () {
    return {
      title: 'Business Trip Imposition',
      actions: [
        { icon: 'add', tooltip: 'Add New', to: {name: 'business-trip-imposition-new'} },
        { icon: 'refresh', handler: this.refresh, tooltip: 'Refresh' }
      ]
    }
  },
  computed: {
    items () {
      return this.$store.state.BusinessTripImposition.items
    },
    loading () {
      return !this.$store.getters['BusinessTripImposition/loaded']
    }
  },
  methods: {
    refresh () {
      const self = this
      self.$store.dispatch('BusinessTripImposition/refresh', {vueinstance: self})
        .catch(err => {
          self.$error(err)
        })
    },
    loadData () {
      const self = this
      self.$store.dispatch('BusinessTripImposition/list', {vueinstance: self})
        .catch(err => {
          self.$error(err)
        })
    }
  },
  mounted () {
    this.loadData()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/master/BusinessTripImposition.vue